import React, { useEffect } from 'react';
import logger from '../utils/logger';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const Spinner: React.FC<SpinnerProps> = ({ size = 'md', className = '' }) => {
  useEffect(() => {
    logger.debug('Spinner', 'Spinner rendered', { size });
  }, [size]);

  const sizeStyles = {
    sm: 'w-8 h-8 border-2',
    md: 'w-12 h-12 border-3',
    lg: 'w-16 h-16 border-4'
  };
  
  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div 
        className={`
          ${sizeStyles[size]}
          border-cosmic-gold border-opacity-20
          border-t-cosmic-gold
          rounded-full
          animate-spin
        `}
      />
    </div>
  );
};

export default Spinner;

